<template>
    <div>
        <div class="w-100">
            <div class="d-flex">
                <div class="w-50 pr-1">
                    <app-form-select-input
                        label="Menú"
                        :options="menus"
                        :required="true"
                        v-model="menuOption.menuId"
                        :hasError="$v.menuOption.menuId.$error"
                        errorMessage="Debe seleccionar el menú"
                        @change="$v.menuOption.menuId.$touch()"
                    />
                </div>
                <div class="w-50 pl-1">
                    <app-form-text-input
                        label="Nombre"
                        id="name"
                        :required="true"
                        :hasError="$v.menuOption.name.$error"
                        errorMessage="Debe escribir el nombre"
                        @input="$v.menuOption.name.$touch()"
                        v-model="menuOption.name"
                    />
                </div>
            </div>
        </div>
        <div class="w-100">
            <div class="d-flex">
                <div class="w-50 pr-1">
                    <app-form-text-input
                        label="nombre de la página"
                        id="to"
                        :required="true"
                        :hasError="$v.menuOption.to.$error"
                        errorMessage="Debe escribir el nombre de la página"
                        @input="$v.menuOption.to.$touch()"
                        v-model="menuOption.to"
                    />
                </div>
                <div class="w-50 pl-1">
                    <app-form-text-input
                        label="Orden"
                        id="order"
                        :hasError="$v.menuOption.order.$error"
                        errorMessage="Debe escribir un número"
                        @input="$v.menuOption.order.$touch()"
                        v-model="menuOption.order"
                    />
                </div>
            </div>
        </div>
        <app-form-textarea-input
            label="Descripción"
            v-model="menuOption.description"
        />
    </div>
</template>

<script>
import permissionManagerRepository from "../../../../repositories/permissionManager.repository.js";
import { required, numeric } from "vuelidate/lib/validators";
export default {
    props: {
        onSave: {
            type: Function
        }
    },
    data() {
        return {
            menus: [],
            menuOption: {
                menuId: "",
                name: "",
                description: "",
                order: "",
                to: ""
            }
        };
    },

    validations: {
        menuOption: {
            name: { required },
            menuId: { required },
            to: { required },
            order: { numeric }
        }
    },

    methods: {
        loadMenus() {
            const pmr = { ...permissionManagerRepository };
            pmr.getAllMenus()
                .then(data => {
                    this.menus = data;
                })
                .catch(error =>
                    toastr.error("Ocurrio un error al cargar los menús")
                );
        },

        saveMenuOption() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const pmr = { ...permissionManagerRepository };
            pmr.saveMenuOption(this.menuOption)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al guardar menú");
                });
        },
        cleanFields() {
            Object.keys(this.menuOption).map(
                key => (this.menuOption[key] = "")
            );
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },

    created() {
        this.loadMenus();
        this.$bus.$on("menu-form.save", this.saveMenuOption);
        this.$bus.$on("menu-form.clean", this.cleanFields);
    },

    beforeDestroy() {
        this.$bus.$off("menu-form.save");
    }
};
</script>

<style></style>
